/* eslint-disable local/i18n-require-translation-wrappers */
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

type MultiplicationTProps = {
  factor1: React.ReactNode
  factor2: React.ReactNode
  result: React.ReactNode
}

const MultiplicationT: React.FC<MultiplicationTProps> = ({ factor1, factor2, result }) => {
  return (
    <Stack
      direction="row"
      useFlexGap
      sx={{
        gap: 0.5,
      }}>
      <Typography>
        {factor1} x {factor2} = <b>{result}</b>
      </Typography>
    </Stack>
  )
}

export default MultiplicationT
